import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconUndoComponent } from "./med-icon-undo.component";

@NgModule({
  declarations: [
    MedIconUndoComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconUndoComponent,
  ],
})
export class MedIconUndoModule { }
